import { useState } from "react";
import UDFEditComponent from "../candidateDateComponents/udfEditComponent";
import UDFDisplayEditableDate from "../candidateDateComponents/udfDisplayEditable";

export const CandidateUDF = ({
  item,
  candidateActivity,
  extraLabel = null,
  isEditable = true,
  disabled = false,
}) => {
  const [isEdit, setIsEdit] = useState(false);

  if (isEdit) {
    return (
      <UDFEditComponent
        item={item}
        onCancel={() => setIsEdit(false)}
        candidateJobEntryId={candidateActivity.id}
      />
    );
  }

  return (
    <UDFDisplayEditableDate
      item={item}
      onEdit={() => setIsEdit(true)}
      isEditable={isEditable}
      disabled={disabled}
      extraLabel={extraLabel}
    />
  );
};
